import React from 'react';
import dayjs from 'dayjs';
import { useGlobalContext } from '../../contexts/GlobalContext';

//Estilos
import './DJCP.css';
import print from '../../assets/imgs/print.png';

//Componentes
import DJCPLogsContainer from '../../components/DJCPLogs/DJCPLogsContainer';
import { formatNumberLength } from '../../helpers';

function DJCP({ functions, states }) {
    const { masters, user, grapesVariety } = useGlobalContext();
    const { formatNumber, setWatchDJCPLogs, handlePrint, setOpenInhabModal } =
        functions;

    const {
        watchDJCPLogs,
        DJCPData: { cabecera, items, usuario, nombre, apellido },
        Coordinates,
        inhabilitateDJCP,
    } = states;

    return (
        <div className="DJCP-container">
            <h4 className="DJCP-title">
                Declaración Jurada de Cosecha Probable {cabecera?.serie}-
                {masters.LetterTypes?.find((lt) => lt.id === 4).nombre}-
                {formatNumber(cabecera?.numero, 4)}
            </h4>
            <section className="DJCP-info-section">
                <label className="DJCP-label">
                    <span>Habilitada: </span>
                    <p>
                        {masters.HabilitationTypes?.find(
                            (ht) => ht.id === cabecera?.habilitada
                        )?.nombre.replace('_', ' ')}
                    </p>
                </label>
                <label className="DJCP-label">
                    <span>Fecha: </span>
                    <p>{dayjs(cabecera?.fecha).format('DD-MM-YYYY')}</p>
                </label>
                <label className="DJCP-label">
                    <span>Padrones: </span>
                    <p>{cabecera?.padrones.replace('_', ', ')}</p>
                </label>
                <label className="DJCP-label">
                    <span>Timbre: </span>
                    <p>{cabecera?.timbre ? 'PAGO' : 'NO PAGO'}</p>
                </label>
                <label className="DJCP-label">
                    <span>Viñedo: </span>
                    <p>{cabecera?.viniedo}</p>
                </label>
                <label className="DJCP-label">
                    <span>Teléfono: </span>
                    <p>{cabecera?.telefono}</p>
                </label>
                <label className="DJCP-label">
                    <span>Titulares: </span>
                    <p>{cabecera?.titulares}</p>
                </label>
                <label className="DJCP-label">
                    <span>Titulares Documentos: </span>
                    <p>{cabecera?.titulares_Documento}</p>
                </label>
                <label className="DJCP-label">
                    <span>Ubicación: </span>
                    <p>
                        Latitud: {formatNumberLength(Coordinates?.lat)},
                        Longitud: {formatNumberLength(Coordinates?.lon)}
                    </p>
                </label>
                <label className="DJCP-label">
                    <span>Departamento: </span>
                    <p>{cabecera?.departamento}</p>
                </label>
                <label className="DJCP-label">
                    <span>Superficie: </span>
                    <p>{cabecera?.total_Superficie} m²</p>
                </label>
                <label className="DJCP-label">
                    <span>Responsable: </span>
                    <p>
                        {nombre} {apellido} ({usuario})
                    </p>
                </label>
            </section>
            <h4 className="DJCP-title">Producción de Uva</h4>
            <section className="DJCP-info-section">
                <table>
                    <thead>
                        <tr>
                            <th>Variedad</th>
                            <th>Superficie</th>
                            <th>Kilos Ingresados</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items?.map((it, i) => {
                            return (
                                <tr key={i}>
                                    <td>
                                        {
                                            grapesVariety?.find(
                                                (gv) =>
                                                    gv.codigo === it.variedad
                                            )?.variedad
                                        }
                                    </td>
                                    <td>{it.superficie} m²</td>
                                    <td>{it.kilos} kg</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </section>
            <footer className="DJCP-footer">
                <label>
                    <span>Total Kilos de Producción: </span>
                    <p>{cabecera?.total_Kilos} kg</p>
                </label>
            </footer>
            <div className="DJCP-btn-footer">
                <button
                    className="btn btn-primary DJCP-btn-print"
                    onClick={handlePrint}
                >
                    <img
                        className="DJCP-img-print"
                        src={print}
                        alt="Impresíon"
                    />
                    <small>Impresión</small>
                </button>
                {user?.tipo === 3 && inhabilitateDJCP && (
                    <button
                        className="btn btn-primary DJCP-btn-print"
                        onClick={() => setOpenInhabModal(true)}
                    >
                        Inhabilitar
                    </button>
                )}
            </div>
            {user?.tipo === 3 && (
                <section className="profile-fieldset_4">
                    <h4 className="profile-title">Historial de la DJCP</h4>
                    <button
                        className="btn btn-primary profile-history_btn"
                        onClick={() => setWatchDJCPLogs(!watchDJCPLogs)}
                    >
                        {!watchDJCPLogs ? 'Ver Historial' : 'Ocultar Historial'}
                    </button>
                    {watchDJCPLogs && <DJCPLogsContainer />}
                </section>
            )}
        </div>
    );
}

export default DJCP;
